<div *ngIf="asLabel; else editableAssignTo">
  <div>{{ displayFn(assigneeFormControl.value) }}</div>
</div>
<ng-template #editableAssignTo>
  <label for="exampleFormControlInput1" class="form-label">Assign to<sup *ngIf="mandatory">*</sup></label>
  <input
    type="text"
    placeholder="Search Assignee"
    [formControl]="assigneeFormControl"
    [matAutocomplete]="auto"
    class="query-name-input form-select-without-bg-img"
    [ngClass]="{ 'is-invalid': mandatory && assigneeFormControl.errors && assigneeFormControl.touched }" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn.bind(this)"
    [ngClass]="{ 'is-invalid': mandatory && assigneeFormControl.errors && assigneeFormControl.touched }"
    (optionSelected)="onSelect($event.option.value)">
    <mat-option *ngFor="let assignee of filteredAssignees | async" [value]="assignee?.id">
      {{ assignee?.employeeCode }}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="mandatory">
    <div *ngIf="assigneeFormControl && assigneeFormControl.errors && assigneeFormControl.touched">
      <div *ngIf="assigneeFormControl.errors.required">This is mandatory, Kindly select assignee</div>
    </div>
  </mat-error>
</ng-template>

